




























































































import Vue from "vue"
import {
    createComponent,
    onMounted,
    reactive,
    ref,
    Ref,
    SetupContext
} from "@vue/composition-api"
import { useStore } from "@/hooks/common"
import { Store } from "vuex"
import { Message, MessageBox } from "element-ui"
import { TableFile, IFile } from "@oppo/slice-uploader/src/types"
import isElectron from "is-electron"
import { SameFileType } from "@/service/public"
import request from "@/helpers/customAxios"
import { getShareFileInfo, ShareFileInfo, notifyUser } from "@/service/common"
import { preTransferHandler, FilePathName } from "@/helpers/common"
import { transferThreshold } from "@/constant"
import $axios from "@/helpers/customAxios"
import {
    desktopUploadHandler,
    dragUploadHandler,
    desktopRetryUpload
} from "@/service/allUse"
import CountDown from "@/components/CountDown.vue"
const inElectron = isElectron()
export default createComponent({
    components: {
        CountDown
    },
    setup(props, setupContext) {
        const store = useStore()
        const infoShow = ref<boolean>(false)
        const id = setupContext.root.$route.query.id as string
        const hasFileUploaded = ref<boolean>(false)
        const { hasAlert, alertHandler } = infoHandle(id, hasFileUploaded)
        const dirInfo = ref<ShareFileInfo>({
            file: {}
        })
        const useSpliceUploadFile = sliceUploader(
            store,
            setupContext,
            dirInfo,
            hasFileUploaded
        )
        const sliceUpload = ref<Vue>(null)
        const canUpload = ref<boolean>(false)
        canUpload.value = !!id
        const selectFileClick = async () => {
            if (!dirInfo.value.file.id) {
                Message.error("分享链接异常，缺少参数")
                return
            }
            if (!canUpload.value) {
                Message.error("文件夹信息异常，暂不可上传")
                return
            }
            //   if (inElectron) {
            // eslint-disable-next-line no-constant-condition
            if (false) {
                console.log("上传请求客户端")
                const dirId = dirInfo.value.file.id
                const shareIdentify = dirInfo.value.shareIdentify
                await desktopUploadHandler(dirId, shareIdentify)
            } else {
                (sliceUpload.value as any).selectFile()
            }
        }

        const fileDragover = e => {
            e.preventDefault()
        }
        const fileDrop = e => {
            e.preventDefault()
            if (!id) {
                Message.error("分享链接异常，缺少参数")
                return
            }
            if (!canUpload.value) {
                Message.error("文件夹信息异常，暂不可上传")
                return
            }
            if (!e.dataTransfer || !e.dataTransfer.files.length) {
                return
            }

            const files = e.dataTransfer.files
            // eslint-disable-next-line no-useless-escape
            const reg = /\.[^\.]+$/ //通过扩展名判断
            //   if (inElectron) {
            // eslint-disable-next-line no-constant-condition
            if (false) {
                const filePath = []
                for (let file of files) {
                    // console.log(file, "zz");
                    //@ts-ignore
                    if (file.path && reg.test(file.name)) {
                        //@ts-ignore
                        filePath.push(file.path)
                    } else {
                        Message.error("不支持文件夹上传！")
                    }
                }
                const dirId = dirInfo.value.file.id
                // todo 需要await吗
                dragUploadHandler(dirId, filePath, id)
            } else {
                let excludeDir: any[] = []
                for (let file of files) {
                    if (reg.test(file.name)) {
                        excludeDir.push(file)
                    } else {
                        Message.error("不支持文件夹上传！")
                    }
                }
                if (!excludeDir.length) {
                    return
                }
                (sliceUpload.value as any).selectDrapFile(files)
            }
        }
        const managers = ref<string>("")
        onMounted(async () => {
            hasAlert.value = false
            if (!id) {
                Message.error("分享链接异常，缺少参数")
                return
            }
            const res = await getShareFileInfo({ id })
            if (res.code === 0) {
                dirInfo.value = res.data
                if (dirInfo.value.notify && dirInfo.value.notify.users) {
                    const managerNames = dirInfo.value.notify.users.map(item => {
                        return !!item.value && item.value
                    })
                    if (managerNames.length) {
                        managers.value = managerNames.join(",")
                    }
                }

                if (
                    new Date(res.data.expireTime).getTime() - new Date().getTime() <=
          0
                ) {
                    setupContext.root.$router.push({
                        path: `/linkinvalid?name=${managers.value}`
                    })
                }
            } else {
                canUpload.value = false
                Message.error(res.desc || "查询文件夹信息失败")
                setupContext.root.$router.push("/nopermission")
            }
        })
        return {
            sliceUpload,
            selectFileClick,
            fileDragover,
            fileDrop,
            dirInfo,
            alertHandler,
            ...useSpliceUploadFile,
            hasAlert,
            canUpload,
            managers,
            hasFileUploaded
        }
    }
})
function infoHandle(id: string, hasFileUploaded: Ref<boolean>) {
    const hasAlert = ref<boolean>()
    const alertHandler = async () => {
        if (!id) {
            Message.error("分享链接异常，缺少参数")
            return
        }
        if (!hasFileUploaded.value) {
            Message.error("尚未上传文件！")
            return
        }
        const res = await notifyUser(id, "inner")
        hasAlert.value = true
        if (!res || res.code !== 0) {
            console.log("通知失败！")
        }
    }
    return {
        hasAlert,
        alertHandler
    }
}
function sliceUploader(
    store: Store<any>,
    setupContext: SetupContext,
    dirInfo,
    hasFileUploaded: Ref<boolean>
) {
    const checkFileHandler = res => {
        if (res.code === 0) {
            return true
        }
        return false
    }
    const checkSameFile = async (file: TableFile) => {
        const query = {
            name: file.name,
            dirId: dirInfo.value.file.id
        }
        let checkType: SameFileType
        let newName = ""
        try {
            let res
            res = await request.get("/api/checkFile", { params: query })
            let sameNameObj
            if (!res || (res && res.code !== 0)) {
                Message.error("检查文件重名出错！")
                return { checkType: SameFileType.ERROR }
            }
            if (res.code === 0) {
                sameNameObj = res.data
            }
            if (sameNameObj) {
                checkType =
          sameNameObj.identifier === file.id
              ? SameFileType.SAME_MD5
              : SameFileType.SAME_NAME
                newName = sameNameObj.rename
            } else {
                checkType = SameFileType.NOT_SAME
            }
        } catch (e) {
            Message.error("检查文件重名出错！")
            checkType = SameFileType.ERROR
        }

        return { checkType, newName }
    }
    const handleSameFile = async (
        fileName: string,
        param: { checkType: SameFileType; newName: string }
    ) => {
        const { checkType, newName } = param
        return new Promise((resolve, reject) => {
            let saveFile = true
            if (checkType === SameFileType.ERROR) {
                saveFile = false
                resolve({ saveFile })
            } else if (checkType === SameFileType.SAME_NAME) {
                const newFileName = newName
                MessageBox.confirm(
                    `系统将上传文件更名为${newFileName},是否继续执行该操作`,
                    "当前路径存在相同文件名",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                )
                    .then(() => {
                        resolve({
                            saveFile,
                            newFileName
                        })
                    })
                    .catch(() => {
                        saveFile = false
                        resolve({
                            saveFile,
                            newFileName
                        })
                    })
            } else {
                if (checkType === SameFileType.SAME_MD5) {
                    saveFile = false
                    hasFileUploaded.value = true
                    Message.success("文件已存在！")
                }
                resolve({ saveFile })
            }
        })
    }
    const shouldAddedFilesUpload = async (files: FileList) => {
        const isContinue = await preTransferHandler({
            files,
            threshold: transferThreshold,
            transType: "upload"
        })
        // const isContinue = true;
        if (isContinue) {
            return files
        } else {
            return []
        }
    }
    const checkFileUploadedChunks = res => {
        let data = []
        if (res.data && res.data.length) {
            data = res.data.map(v => {
                // 后台索引是1开始的
                return v - 1
            })
        }
        if (res.code != 0) {
            Message.error(res.desc)
        }
        return data
    }
    const hasAlertSuccess = ref<boolean>(false)
    const onFileSuccess = (res, file: TableFile) => {
    // store.dispatch("publicStore/getTableData");
        if (hasAlertSuccess.value) {
            return
        }
        hasFileUploaded.value = true
        Message.success("上传成功！")
    }
    const onFileStateSuccess = (file: TableFile) => {
    // store.dispatch("publicStore/getTableData");
        hasFileUploaded.value = true
        hasAlertSuccess.value = true
        Message.success("上传成功！")
    }
    const onFileError = (res, file: TableFile) => {
        const msg = `${file.name} | ${res.desc || "文件上传失败[未知原因]"}`
        Message.error(msg)
    }
    const onFilecheckError = (err: any, file: IFile) => {
        const msg = `${file.name} | ${err.desc || "文件上传失败[未知原因]"}`
        Message.error(msg)
    }
    const onFileMd5Error = () => {
        Message.error("计算文件MD5值出错")
    }
    const id = setupContext.root.$route.query.id as string
    const formatCheckFileHttpParam = params => {
        return Object.assign(params, { shareIdentify: id })
    }
    const formatSendFileHttpParam = params => {
        return Object.assign(params, { shareIdentify: id })
    }
    const formatSaveFileHttpParam = params => {
        return Object.assign(params, { shareIdentify: id })
    }

    return {
        checkFileHandler,
        checkSameFile,
        handleSameFile,
        shouldAddedFilesUpload,
        checkFileUploadedChunks,
        onFileSuccess,
        onFileError,
        onFilecheckError,
        onFileMd5Error,
        onFileStateSuccess,
        formatCheckFileHttpParam,
        formatSendFileHttpParam,
        formatSaveFileHttpParam,
        hasAlertSuccess
    }
}
